import { toast } from 'react-toastify';

import { all, takeLatest, call, put } from 'redux-saga/effects';

import api from '~/services/api';

import {
  getCommentsSuccess,
  getCommentsFailure,
  commentTaskSuccess,
  commentTaskFailure,
  updateTaskCommentSuccess,
  updateTaskCommentFailure,
  deleteTaskCommentSuccess,
  deleteTaskCommentFailure,
} from './actions';
import {
  IGetCommentsRequestAction,
  ICommentTaskRequestAction,
  ICommentsTypes,
  IUpdateTaskCommentRequestAction,
  IDeleteTaskCommentRequestAction,
} from './types';

export function* getTaskComments({
  payload,
}: IGetCommentsRequestAction): unknown {
  const { processInstanceId } = payload;

  try {
    const response = yield call(api.get, `/comments/${processInstanceId}`);
    const comments = response.data;

    yield put(getCommentsSuccess(comments));
  } catch (err) {
    yield put(getCommentsFailure());
    toast.error('Erro ao buscar comentários da tarefa.');
  }
}

export function* commentTask({ payload }: ICommentTaskRequestAction): unknown {
  const {
    processInstanceId,
    taskId,
    taskName,
    userId,
    userFirstName,
    userLastName,
    userAvatar,
    content,
  } = payload;

  try {
    yield call(api.post, `/comments`, {
      processInstanceId,
      taskId,
      taskName,
      userId,
      userFirstName,
      userLastName,
      userAvatar,
      content,
    });

    const commentsResponse = yield call(
      api.get,
      `/comments/${processInstanceId}`,
    );

    const comments = commentsResponse.data;

    yield put(commentTaskSuccess(comments));
  } catch (err) {
    yield put(commentTaskFailure());
    toast.error('Erro ao comentar em tarefa.');
  }
}

export function* updateTaskComment({
  payload,
}: IUpdateTaskCommentRequestAction): unknown {
  const { id, processInstanceId, content } = payload;

  try {
    yield call(api.put, `/comments/${id}`, {
      content,
    });

    const commentsResponse = yield call(
      api.get,
      `/comments/${processInstanceId}`,
    );

    const comments = commentsResponse.data;

    yield put(updateTaskCommentSuccess(comments));
  } catch (err) {
    yield put(updateTaskCommentFailure());
    toast.error('Erro ao editar comentário.');
  }
}

export function* deleteTaskComment({
  payload,
}: IDeleteTaskCommentRequestAction): unknown {
  const { id, processInstanceId, taskId } = payload;

  try {
    yield call(api.delete, `/comments/${id}/${taskId}`);

    const commentsResponse = yield call(
      api.get,
      `/comments/${processInstanceId}`,
    );

    const comments = commentsResponse.data;

    yield put(deleteTaskCommentSuccess(comments));
  } catch (err) {
    yield put(deleteTaskCommentFailure());
    toast.error('Erro ao excluir comentário.');
  }
}

export default all([
  takeLatest(ICommentsTypes.GET_TASK_COMMENTS_REQUEST, getTaskComments),
  takeLatest(ICommentsTypes.COMMENT_TASK_COMMENTS_REQUEST, commentTask),
  takeLatest(ICommentsTypes.UPDATE_TASK_COMMENT_REQUEST, updateTaskComment),
  takeLatest(ICommentsTypes.DELETE_TASK_COMMENT_REQUEST, deleteTaskComment),
]);
